import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MeetingActionComponent } from 'src/app/pages/operator/components/meeting-action/meeting-action.component';
import { HttpService } from 'src/app/services/http.service';
import { LoginService } from 'src/app/services/login.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { CalendarService } from '../calendar/services/calendar.service';
import { MeetingListComponent } from './components/meeting-list/meeting-list.component';

@Component({
  selector: 'app-operator',
  templateUrl: './operator.page.html',
  styleUrls: ['./operator.page.scss'],
})
export class OperatorPage implements OnInit, OnDestroy {
  public defaultImg = environment.defaultImg;
  public date = undefined;
  public meetings: any[] = [];
  public operator = undefined;
  public service = undefined;
  private _domainId = environment.domainId;
  private _calendarObs = new Subscription();
  public rolId = 6;
  public orderBy = 1;
  public page = 1;
  public lastPage = 1;
  public search = '';
  public lastDate = undefined;
  public isLoading = true;

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private calendarSv: CalendarService,
    private loginSv: LoginService
  ) {}

  async ngOnInit() {
    try {
      this.service = await this.httpSv.getProduct(4, 'services');
      const sv = this.calendarSv.emitNewDate.subscribe(async (date) => {
        this.lastDate = date;
        await this.changeDate();
      });
      this._calendarObs.add(sv);
      this.lastDate = new Date();
      this.changeDate();
    } catch (err) {
      console.error(err);
    }
  }

  trackByItems(index, item) {
    return item.id;
  }

  ngOnDestroy(): void {
    this._calendarObs.unsubscribe();
  }

  async changeDate() {
    try {
      this.isLoading = true;
      this.date = undefined;
      this.operator = this.service.operators[0];
      const user = this.loginSv?.user;
      const rolId = user?.rolId || null;
      this.rolId = rolId;
      const param = {
        domainId: this._domainId,
        isOperator: rolId === 8 ? 1 : 0,
        isClient: rolId === 6 ? 1 : 0,
        isAdmin: rolId === 3 ? 1 : 0,
        orderBy: this.orderBy,
        toDate: this.lastDate,
        search: this.search,
      };
      const res = await this.httpSv.itemIndex('operators', '', param);
      setTimeout(() => {
        this.date = { data: res.data, actualDate: this.lastDate };
        this.date.data.meeting.forEach((item) => {
          const spliatedDate = item.date.split('/');
          item.date = `${spliatedDate[1]}-${spliatedDate[0]}-${spliatedDate[2]}`;
        });
        this.meetings = this.date.data.meeting;
        this.isLoading = false;
      }, 100);
    } catch (err) {
      console.error(err);
    }
  }

  async changeState(meeting) {
    await this.uiSv.showModal(
      MeetingActionComponent,
      { meeting },
      'meeting-action'
    );
  }

  filterOperator(ev) {
    const data = ev.detail.value;
    this.orderBy = data;
    this.changeDate();
  }

  doSearch(ev) {
    this.search = ev;
    this.changeDate();
  }

  async openAgendedList(date) {
    const normalizedDate = new Date(date);
    const filteredPerDate = this.meetings.filter((x) => x.date === date);
    const { data } = await this.uiSv.showModal(
      MeetingListComponent,
      {
        normalizedDate,
        filteredPerDate,
      },
      'meeting-list'
    );

    if (data === 'deleted') {
      this.changeDate();
    }
  }
}
